import { render, staticRenderFns } from "./topicDetailsList.vue?vue&type=template&id=494f1805&scoped=true&"
import script from "./topicDetailsList.vue?vue&type=script&lang=js&"
export * from "./topicDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./topicDetailsList.vue?vue&type=style&index=0&id=494f1805&prod&lang=css&"
import style1 from "./topicDetailsList.vue?vue&type=style&index=1&id=494f1805&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f1805",
  null
  
)

export default component.exports